import { cleanSessionStorage } from '../pages/vehicle-configurator/util/sessionStorageUtil'
import { AppState } from './auth/authContext'

export const businessStateKeys: string[] = [
  'caseId',
  'renewalId',
  'opportunityId',
  'customerId',
  'policyLevel',
  'draftPolicy',
  'driverCase',
  'submittedQuoteNumber',
]

export const getCurrentAppState = (appState: AppState = {}): AppState => {
  const query = new URLSearchParams(window.location.search)
  // An explicit entry is one complete business context, not a per-field merge.
  const newEntry = businessStateKeys.some((key) => query.has(key))
  const explicitState = businessStateKeys.some(
    (key) => appState[key as keyof AppState] !== undefined,
  )
  const read = (key: string) =>
    explicitState
      ? undefined
      : newEntry
      ? query.get(key) || undefined
      : window.sessionStorage.getItem(key) || undefined
  return {
    returnTo:
      window.location.pathname + window.location.search + window.location.hash,
    caseId: read('caseId'),
    renewalId: read('renewalId'),
    opportunityId: read('opportunityId'),
    customerId: read('customerId'),
    policyLevel: read('policyLevel'),
    draftPolicy: read('draftPolicy') || 'false',
    driverCase: read('driverCase') === 'true',
    submittedQuoteNumber: read('submittedQuoteNumber'),
    ...appState,
  }
}

export const setAppState = (appState: AppState, newEntry = false) => {
  if (appState?.driverCase === true) {
    if (newEntry || window.sessionStorage.getItem('driverCase') !== 'true') {
      cleanSessionStorage([])
    }
    window.sessionStorage.setItem('driverCase', 'true')
    return
  }
  const values: Record<string, string> = {
    caseId: appState?.caseId,
    renewalId: appState?.renewalId,
    opportunityId: appState?.opportunityId,
    customerId: appState?.customerId,
    policyLevel: appState?.policyLevel,
    submittedQuoteNumber: appState?.submittedQuoteNumber,
  }
  if (appState?.customerId && appState?.policyLevel) {
    values.draftPolicy = appState.draftPolicy || 'false'
  }
  const keys = Object.keys(values).filter((key) => !!values[key])
  if (keys.length || appState.driverCase === false) {
    const changed = businessStateKeys.some(
      (key) =>
        (window.sessionStorage.getItem(key) || undefined) !== values[key],
    )
    if (changed) cleanSessionStorage(keys)
    keys.forEach((key) => window.sessionStorage.setItem(key, values[key]))
  }
}
